import { Button, Card, Form } from 'react-bootstrap';
import React, { useCallback, useEffect, useState } from 'react';
import { PlusLg } from 'react-bootstrap-icons';
import NewAttachmentItem from '../Partials/NewAttachmentItem';
import AttachmentItem from '../Partials/AttachmentItem';

const defaultAttachment = {
  fileName: '',
  file: null,
};

export default function Attachments({ data, onChange, isValid, disabled }) {
  const [notValidItems, setNotValidItems] = useState([]);
  const deleteAttachment = useCallback((index) => {
    onChange([...data.attachments.filter((v, i) => i !== index)], 'attachments')
  }, [data]);

  return (
    <Card className="mb-4">
      <Card.Header as={Card.Title} className="p-4">
        Приложения
      </Card.Header>
      <Card.Body className='d-flex flex-column gap-4'>
        {data.attachments.map((a, i) =>
          (a.id ? (
            <AttachmentItem
              key={i}
              info={{ ...a, number: i }}
              url={`/minioFiles/download/${a.id}`}
              onDelete={deleteAttachment}
              onChange={onChange}
              attachments={data.attachments}
              disabled={disabled}
            />
          ) : (
            <NewAttachmentItem
              key={i}
              info={{ ...a, number: i }}
              onDelete={deleteAttachment}
              onChange={onChange}
              attachments={data.attachments}
              isValid={isValid}
            />
          ))
        )}
        <Button
          onClick={() => {
            onChange([...data.attachments, { ...defaultAttachment }], 'attachments');
          }}
          disabled={disabled}
          className='me-auto'
          variant="outline-primary">
          <PlusLg className="me-1 mb-1" />
          Добавить приложение
        </Button>
      </Card.Body>
    </Card>
  );
}


